import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid, Stack } from '@mui/material'
import {
    RegisteredDecimalField,
    RegisteredIntegerField,
    RegisteredNumericField,
} from '../../../../components/fields/NumericField'
import { RegisteredCheckBox } from '../../../../components/fields/CheckBox'
import { RegisteredTextField } from '../../../../components/fields/TextField'
import { FormTable, FormTableRow } from '../../issues/FormTable'
import { RegisteredDatePicker } from '../../../../components/fields/DatePicker'
import { ConvertibleEntity } from 'types/ConvertibleEntity'

function TermsFields({
    convertible,
    setIsCustomFormDirty,
}: {
    convertible: ConvertibleEntity
    setIsCustomFormDirty: (v: boolean) => void
}) {
    const formMethods = useFormContext()

    if (!convertible) return null

    const isVwapChecked = !!formMethods.watch('vwap')

    const validatePercentage = () => (_value: string) => {
        if (parseFloat(_value) === 0) return false

        return true
    }

    return (
        <>
            <FormTable>
                <FormTableRow label='Lånebelopp'>
                    <RegisteredNumericField label='Konvertibelns lånebelopp' name='loanAmount' decimals={0} />
                </FormTableRow>
                <FormTableRow label='Förfallodatum'>
                    <Stack spacing={2}>
                        <RegisteredDatePicker name='maturityDate' label='Förfallodatum' fullWidth />
                        <RegisteredCheckBox
                            label='Kan konverteras när som helst'
                            name='convertAnytime'
                            onChange={() => setIsCustomFormDirty(true)}
                        />
                    </Stack>
                </FormTableRow>
                <FormTableRow label='Räntor och avgifter'>
                    <Stack direction='column' spacing={2}>
                        <RegisteredDecimalField
                            label='Uppläggningsavgift'
                            name='arrangementFee'
                            validation={{ validate: validatePercentage() }}
                        />
                        <RegisteredDecimalField
                            label='Månadsränta'
                            disabled={!!formMethods.getValues('annualInterest')}
                            name='monthlyInterest'
                            validation={{ validate: validatePercentage() }}
                        />
                        <Stack direction='row' alignContent='center'>
                            <RegisteredCheckBox
                                label='STIBOR'
                                name='stibor'
                                disabled={!!formMethods.getValues('monthlyInterest')}
                                onChange={() => setIsCustomFormDirty(true)}
                            />
                            <RegisteredDecimalField
                                label='Årsränta'
                                disabled={!!formMethods.getValues('monthlyInterest')}
                                name='annualInterest'
                                validation={{ validate: validatePercentage() }}
                            />
                        </Stack>
                    </Stack>
                </FormTableRow>
                <FormTableRow label='Fast konvertering'>
                    <RegisteredDecimalField
                        label='Fast konverteringskurs'
                        name='fixedConversionPrice'
                        disabled={isVwapChecked}
                    />
                </FormTableRow>
                <FormTableRow label='Rörlig konvertering'>
                    <Stack spacing={2}>
                        <RegisteredCheckBox
                            label='VWAP'
                            name='vwap'
                            disabled={!!formMethods.getValues('fixedConversionPrice')}
                            onChange={() => setIsCustomFormDirty(true)}
                        />
                        {isVwapChecked ? (
                            <>
                                <RegisteredDecimalField label='Rabatt' name='vwapDiscount' disabled={!isVwapChecked} />
                                <RegisteredIntegerField label='Antal dagar' name='vwapDays' disabled={!isVwapChecked} />
                                <RegisteredDecimalField label='Minimumkurs' name='priceMin' disabled={!isVwapChecked} />
                                <RegisteredDecimalField label='Maximumkurs' name='priceMax' disabled={!isVwapChecked} />
                            </>
                        ) : null}
                    </Stack>
                </FormTableRow>

                <FormTableRow label='Särskilda villkor'>
                    <RegisteredTextField
                        label='Apportegendom'
                        name='noncashConsideration'
                        fullWidth
                        multiline
                        minRows={3}
                    />
                </FormTableRow>
            </FormTable>
            <Grid spacing={2} direction='row' container pt={4}>
                <Grid size={6}>
                    <RegisteredTextField
                        name='internalComment'
                        sx={{ width: '100%' }}
                        label='Intern Kommentar'
                        multiline
                        minRows={3}
                    />
                </Grid>
                <Grid size={6}>
                    <RegisteredTextField
                        name='externalComment'
                        sx={{ width: '100%' }}
                        label='Extern Kommentar'
                        multiline
                        minRows={3}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default TermsFields
